<template>
  <div class="container container-width">
    <div>
      <b-card class="mt-5 max-width">
        <!-- Logo -->
        <div class="d-flex justify-content-center align-items-center mr-3 mt-2 mb-4">
          <img
            class="logo-login"
            :src="`${publicUrl}img/logo/eines-logo.svg`"
            alt
          />
        </div>
        <!-- / Logo -->

        <h4 class="text-center mt-3 mb-2">
          {{ $t("register.account") }}
        </h4>

        <div class="text-center mt-2 mb-2">
          {{ $t("register.alreadyaccount") }}
          <a href="#/login">{{ $t("login.login") }}</a>
        </div>

        <b-alert
          class="font-weight-normal"
          v-model="showPasswordAlert"
          variant="danger"
          dismissible
        >
          Your name or email is already registered.
        </b-alert>

        <b-alert
          class="font-weight-normal"
          v-model="showErrorAlert"
          variant="danger"
          dismissible
        >
          Something went wrong. Please contact support@aquaservices.no for
          support.
        </b-alert>

        <!-- Form -->
        <form class="my-4 p-2" @submit.prevent="register">
          <b-form-group :label="$t('register.username')">
            <b-input v-model="account.username" required autofocus />
          </b-form-group>
          <b-form-group :label="$t('register.email')">
            <b-input v-model="account.email" required />
          </b-form-group>
          <b-form-group :label="$t('register.phone')">
            <b-input v-model="account.phone" required />
          </b-form-group>
          <b-form-group :label="$t('register.password')">
            <b-input type="password" v-model="account.password" required />
          </b-form-group>

          <b-button
            variant="primary"
            v-if="submitbutton == true"
            :block="true"
            type="submit"
            class="mt-4"
            >{{ $t("register.createaccount") }}</b-button
          >

          <b-button
            disabled
            v-if="submitbutton == false"
            variant="primary"
            :block="true"
            class="mt-4"
            >{{ $t("register.createaccount") }}</b-button
          >

          <div class="small mt-4">
            Ved å klikke "Opprett konto", aksepterer du villkår for bruk og personvernerklæring. Vi kan sende deg informasjon på epost vedrørende tjenesten eller din konto.
          </div>
        </form>
        <!-- / Form -->
      </b-card>

      <div class="text-center mt-1">
        <small class="text-muted">&copy; 2025 - Eines AS</small>
      </div>
    </div>
  </div>
</template>
      
<script>
export default {
  data() {
    return {
      account: {
        username: "",
        email: "",
        phone: "",
        password: "",
        language: "no",
        wizard: false,
      },
      submitbutton: true, // Always enabled since recaptcha is removed
      password_confirmation: "",
      isLoading: false,
      fullPage: true,
      showPasswordAlert: false,
      showErrorAlert: false,
    };
  },
  methods: {
    register: function () {
      this.isLoading = true;
      this.$store
        .dispatch("register", this.account)
        .then(() =>
          this.$store.dispatch("login", {
            identifier: this.account.email,
            password: this.account.password,
          })
        )
        .then(() => this.$router.push("/wizard"))
        .catch((error) => {
          // Error
          if (error.response) {
            this.showPasswordAlert = true;
            this.isLoading = false;
          } else if (error.request) {
            this.showErrorAlert = true;
            this.isLoading = false;
          } else {
            this.showErrorAlert = true;
            this.isLoading = false;
          }
        });
    },
  },
};
</script>

<style src="@/vendor/styles/pages/authentication.scss" lang="scss"></style>

<style lang="css">
.logo-login {
  width: 200px !important;
}

.container-width {
  max-width: 475px !important;
}
</style>
